import React, { useState, useCallback } from 'react'
import styled from 'styled-components'

import LoadingImage from '@babelcoder/gatsby-theme-base/assets/images/loading.svg'

const Wrapper = styled.div`
  position: relative;
`

const LoadingImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const StyledIframe = styled.iframe`
  width: 100%;
  height: 500px;
  border: 0;
  border-radius: 4px;
  overflow: hidden;
`

export default function Codesandbox({ url }) {
  const [isLoading, setIsLoading] = useState(true)

  const onLoad = useCallback(() => setIsLoading(false), [setIsLoading])

  return (
    <Wrapper>
      <LoadingImageWrapper>
        {isLoading && <LoadingImage></LoadingImage>}
      </LoadingImageWrapper>
      <StyledIframe
        onLoad={onLoad}
        src={`${url}?fontsize=14&hidenavigation=1&theme=dark&view=editor`}
        title="babelcoder-courses"
        allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
        sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
      ></StyledIframe>
    </Wrapper>
  )
}
